import React, { useState, useEffect } from "react";
import { BackToscreenIcon, DesktopBack } from "./Cart";
import "./PatientDetails.css";
import { Scroll } from "../Scroll function/scroll";
import { useHistory } from "react-router-dom";
import { Warning, Regards } from "../Plan-detail/NewPlanComponent";
import { getCartDetails, getAreaPincode, setCity } from "../../Redux/Actions";
import { connect, useSelector, useDispatch } from "react-redux";
import Loader from "../Loader/Loader";
import NewHeader from "../NewHeader/NewHeader";
import PatientActions from "./PatientDetailsAction";

function PatientDetails(props) {
  const history = useHistory();
  //props
  const [coupnDis, setCoupn] = useState(props.location.state ?? 0);

  const [selectCity, setSelectCity] = useState("");
  const [Name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [year, setYear] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [nameErr, setNameErr] = useState("");
  const [mobileErr, setMobileErr] = useState("");
  const [yearErr, setYearErr] = useState("");
  const [genderErr, setGenderErr] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [pincodeErr, setPinCodeErr] = useState("");
  const [selectCityErr, setselectCityErr] = useState("");
  const [selectpincodeErr, setSelectPinCodeErr] = useState(
    "Please select pincode from list below"
  );

  console.log(year,"<<<<<<<")
  const initailValue = {
    name: "",
    mobile: "",
    year: "",
    gender: "",
    email: "",
    area: "",
    city: "",
  };
  const [patientDFormValue, setPatientFV] = useState(initailValue);
  const [isSubmit, setIsSubmit] = useState(false);
  const [showDetails, setShowDetails] = useState(true);
  const [areApin, setpin] = useState("");

  const navCity = useSelector((state) => state.navCityList);
  const { navCities, loading: navCityLoading } = navCity;

  const pincodeDetails = useSelector((state) => state.areaPincodeReducer);

  const { loading: pincodeLoading, areaPincode } = pincodeDetails;
  const { loading: errorPinCodeLoading, error } = pincodeDetails;

  const citySelected = useSelector((state) => state.cityOnTopNav);
  const currentcity = citySelected.citySelect;

  //const dispatch
  const dispatch = useDispatch();
  useEffect(() => {
    const datakey = JSON.parse(localStorage.getItem("user"));
    const token = datakey.token;
    dispatch(getCartDetails(token, currentcity));
    props.getProfileDetails(token);
  }, []);

  useEffect(() => {
    if (selectCity !== "" && props.PinCodeNotFound) {
      setPinCodeErr(props.PinCodeNotFound);
    }
  }, [props.PinCodeNotFound]);

  // useEffect(() => {
  //   console.log(areaPincode,'pincode not founddddddd')
  //   if(selectCity != ''){
  //     setPinCodeErr('Pincode not available. Please choose another')
  //   }else{
  //     setPinCodeErr('')
  //   }
  // }, [pincodeLoading]);

  useEffect(() => {
    setName(props?.userProfile?.fullname);
    setMobile(props?.userProfile?.phonenumber);
    setYear(props?.userProfile?.age ?? "");
    setEmail(props?.userProfile?.email);
    setPatientFV({
      ...patientDFormValue,
      name: `${props?.userProfile?.fullname}`,
      mobile: `${props?.userProfile?.phonenumber}`,
      email: `${props?.userProfile?.email}`,
      year: `${props?.userProfile?.age ?? ""}`,
    });
  }, [props.userProfile]);

  // useEffect(() => {
  //   console.log("current city", currentcity);
  // }, [currentcity]);

  console.log(props.userProfile,patientDFormValue,"<<<<<<>>>>>>")
  //GETTING CART DETAILS
  const cartDetails = useSelector((state) => state.CartReducer);
  const { loading, cartDetails: cartdata } = cartDetails;

  const patientHandleName = (e) => {
    setName(e.target.value);
    const { name, value } = e.target;
    const characterRegex =/^([A-Za-z]+[ ]?)+$/;
    setNameErr("");
    if (!e.target.value.match(characterRegex)) {
      setNameErr("invalid user name");
      setPatientFV({ ...patientDFormValue, [name]: "" });
    } else {
      setPatientFV({ ...patientDFormValue, [name]: value });
    }
    if (e.target.value == "") {
      setNameErr("");
    }
  };

  const patientHandleMobile = (e) => {
    setMobile(e.target.value);
    console.log(e.target.value, "mobile number");
    const { name, value } = e.target;
    const characterRegex =/^([A-Za-z]+[ ]?)+$/;
    let phoneno = /^\d{10}$/;
    let mb = /^[0-9\b]+$/;

    if (mb.test(e.target.value) == false && e.target.value.length != 10) {
      setMobileErr("Only number allowed in Mobile.");
      setPatientFV({ ...patientDFormValue, [name]: "" });
    }
    if (!e.target.value) {
      setMobileErr("Mobile is required.");
      setPatientFV({ ...patientDFormValue, [name]: "" });
    }
    if (e.target.value.length != 10 && mb.test(e.target.value) == true) {
      setMobileErr("Enter 10 digit mobile number");
      setPatientFV({ ...patientDFormValue, [name]: "" });
    }
    if (e.target.value.charAt(0) < 6 && mb.test(e.target.value) == true) {
      setMobileErr("Mobile Number should start with digit 6,7,8 or 9");
      setPatientFV({ ...patientDFormValue, [name]: "" });
    }
    if (
      e.target.value.length == 10 &&
      e.target.value.charAt(0) >= 6 &&
      mb.test(e.target.value) == true
    ) {
      setMobileErr("");
      setPatientFV({ ...patientDFormValue, [name]: value });
    }
    if (e.target.value == "") {
      setMobileErr("");
    }
    // const { name, value } = e.target;
    // setPatientFV({ ...patientDFormValue, [name]: value });
    // setPatientFError(validate(patientDFormValue));
    // setPatientFError(validate({[name]: value}));
    // console.log(patientDFormError,'patient form error')
  };

  const patientHandleAge = (e) => {
    setYear(e.target.value);
    const { name, value } = e.target;

    if (e.target.value <= 0 || e.target.value >= 104) {
      setYearErr("Age is required");
      setPatientFV({ ...patientDFormValue, [name]: "" });
    } else if (e.target.value.includes("-")) {
      setYearErr("Not a valid age");
      setPatientFV({ ...patientDFormValue, [name]: "" });
    } else {
      setYearErr("");
      setPatientFV({ ...patientDFormValue, [name]: value });
    }
    // if (e.target.value == "") {
    //   setYearErr("");
    // }
  };
  const patientHandleGender = (e) => {
    setGender(e.target.value);
    const { name, value } = e.target;
    if (!e.target.value) {
      setGenderErr("Gender is required.");
      setPatientFV({ ...patientDFormValue, [name]: "" });
    } else {
      setPatientFV({ ...patientDFormValue, [name]: value });
      setGenderErr("");
    }
    if (e.target.value == "") {
      setGenderErr("");
    }
  };
  const patientHandleEmail = (e) => {
    setEmail(e.target.value);
    const { name, value } = e.target;

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!e.target.value) {
      setEmailErr("Email is required.");
    }
    if (!regex.test(e.target.value)) {
      // errors.email = "This is not a valid Email Format";
      setEmailErr("This is not a valid Email Format");
      setPatientFV({ ...patientDFormValue, [name]: "" });
    } else {
      setEmailErr("");
      setPatientFV({ ...patientDFormValue, [name]: value });
    }
    if (e.target.value == "") {
      setEmailErr("");
      setPatientFV({ ...patientDFormValue, [name]: "" });
    }
  };

  var deliveryCharges = 0;
  const [details, setDetails] = useState([]);

  useEffect(() => {
    if (
      cartDetails &&
      cartDetails.cartDetails &&
      cartDetails.cartDetails[0] &&
      cartDetails.cartDetails[0].product
    ) {
      setDetails(cartDetails.cartDetails[0].product);
    }
  }, [cartDetails && cartDetails]);

  useEffect(() => {
    Scroll();
  }, []);

  if (details !== "") {
    var sum = details.reduce((currentSum, nextObject) => {
      // Note that you need to coerce points_earned
      // to a Number or it will simply concatenate the strings
      return (currentSum += nextObject?.package?.package_city_prices
        ? nextObject?.package?.package_city_prices?.package_price
        : nextObject?.package?.package_price);

      // 0 is your initial value used by currentSum in
      // the first iteration
    }, 0);

    console.log("this is some", sum);
  }
  if (details !== "") {
    var offerSum = 0;
    let numOfTrue = 0;
    // console.log(details, "Lenght Detail obj")
    details.map((item) => {
      if (item?.package?.is_addon) {
        numOfTrue += 1;
      }
    });

    if (details.length == numOfTrue) {
      console.log("all are add on packages");
      offerSum = details.reduce((currentOfferSum, nextObject) => {
        currentOfferSum += nextObject?.package?.package_city_prices
          ? nextObject?.package?.package_city_prices?.offer_price
          : nextObject?.package?.offer_price;
        console.log(
          nextObject?.package?.package_city_prices
            ? nextObject?.package?.package_city_prices?.offer_price
            : nextObject?.package?.offer_price,
          "Now only offer price"
        );
        return currentOfferSum;
      }, 0);
    } else {
      // props.setAllAddonFalse()
      console.log("all are not add on");
      offerSum = details.reduce((currentOfferSum, nextObject) => {
        if (nextObject?.package?.is_addon) {
          currentOfferSum += nextObject?.package?.addon_price;
          console.log(
            nextObject?.package?.addon_price,
            " Add on price package found"
          );
        } else if (!nextObject?.package?.is_addon) {
          currentOfferSum += nextObject?.package?.package_city_prices
            ? nextObject?.package?.package_city_prices?.offer_price
            : nextObject?.package?.offer_price;
          console.log(
            nextObject?.package?.package_city_prices
              ? nextObject?.package?.package_city_prices?.offer_price
              : nextObject?.package?.offer_price,
            "Offer price/pack citywise package found"
          );
        }
        return currentOfferSum;
      }, 0);
    }

    if (offerSum < 99) {
      deliveryCharges = 200;
    }
  }
  if (details !== "") {
    var discountSum = sum - offerSum;
    var discountPercent = Math.floor((discountSum / sum) * 100);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      patientDFormValue.name != "" &&
      patientDFormValue.mobile != "" &&
      patientDFormValue.year != "" &&
      patientDFormValue.gender != "" &&
      patientDFormValue.email != "" &&
      areApin !== ""&&email!==null
    ) {
      setIsSubmit(true);
      localStorage.setItem("patientDetail", JSON.stringify(patientDFormValue));
    } else {
      if (Name == "") {
        setNameErr("Name is required");
      }
      if (email == ""||email===null) {
        setEmailErr("Email is required");
      }
      if (mobile == "") {
        setMobileErr("Mobile is required");
      }
      if (year == "") {
        setYearErr("Age is required");
      }
      if (gender == "") {
        setGenderErr("Gender is required");
      }
      if (areApin == "") {
        setPinCodeErr("Pincode is required");
      }
    }
  };

  const cityHandleSubmit = (e) => {
    const userProfile = JSON.parse(localStorage.getItem("user"));
    const { name, value } = e.target;
    localStorage.setItem("city", e.target.value);
    setPatientFV({ ...patientDFormValue, [name]: value });
    setselectCityErr("");
    dispatch(setCity(e.target.value));
    setSelectCity(e.target.value);
    setpin("");
    e.target.blur();
    dispatch(getAreaPincode("", e.target.value && e.target.value));

    // userProfile && userProfile !=="" ?   dispatch(EmptyCart(userProfile &&  userProfile.token,successCd)) : null
  };

  // useEffect(() => {
  //   // console.log(patientDFormError, "form errorr");
  //   // if (Object.keys(patientDFormError).length === 0 && isSubmit) {
  //   //   // console.log(patientDFormValue, "form valueee");
  //   //   // console.log(isSubmit, "is submitttt");
  //   // }
  // }, [Name, mobile, year, gender, email]);

  const [pinList, setPinList] = useState(false);
  const [finalPin, setfinalPin] = useState("");

  //const pincode handler
  const handelPincode = (e) => {
    console.log(e.target.value);
    const { name, value } = e.target;
    const characterRegex =/^([A-Za-z]+[ ]?)+$/;
    let phoneno = /^\d{10}$/;
    if (
      !e.target.value.match(phoneno) &&
      e.target.value.match(characterRegex)
    ) {
      setPinCodeErr("Only number allowed in PinCode.");
      setPatientFV({ ...patientDFormValue, [name]: "" });
      console.log(pincodeErr, "error messageeeee");
    } else {
      setPinCodeErr("");
      currentcity &&
        dispatch(getAreaPincode(e.target.value, currentcity && currentcity));
      setPinList(true);
    }
    setpin(e.target.value);
  };

  //added changes

  const handelPincodeList = (values) => {
    setpin(values.pincode);
    setfinalPin(values);
    setPinList(false);
    console.log("pincode data", values);
    values.currentCity = currentcity;
    console.log("new object", values);
    setPatientFV({ ...patientDFormValue, area: values });
  };

  return (
    <>
      <NewHeader />
      <BackToscreenIcon title="Patient Details" currpath="ps" />

      {/* <BackToscreen title="Patient Address" /> */}
      <div className="patientDetails patient-margin">
        <DesktopBack title="Patient Details" currpath="ps" />
        {/* <div className="back_btn">
          <Link to="/userdashboard">
            <FaArrowLeft />
            Patient Details
          </Link>
        </div> */}

        <div className="cart_main">
          <div className="cart_leftSide  ">
            <Warning desc="These details will appear on your final test reports" />
            {isSubmit && finalPin !== "" && areApin !== ""
              ? history.push({
                  pathname: `/address`,
                  state: coupnDis,
                })
              : null}
            <div className="patientForm  neonBox">
              {/* <h1 style={{ color: "#31CCB0" }}>Smart Full Body Checkup</h1> */}
              <form onSubmit={handleSubmit}>
                <div className="d_flex flex_column ">
                  <label className="patientLabel">PATIENT'S NAME</label>
                  <input
                    type="text"
                    placeholder="Enter Name"
                    className="patentInput"
                    name="name"
                    value={Name}
                    onChange={patientHandleName}
                    required
                  />
                  <p className="error">{nameErr}</p>
                </div>
                <div className="d_flex flex_column ">
                  <label className="patientLabel">MOBILE NUMBER</label>
                  <input
                    type="number"
                    placeholder="Enter Mobile Number"
                    className="patentInput"
                    name="mobile"
                    onChange={patientHandleMobile}
                    value={mobile}
                    required
                  />
                  <p className="error">{mobileErr}</p>
                </div>
                {/**added pncode here */}
                <div className="bottom_form cityAndPincode">
                  <div className="d_flex flex_column">
                    <label className="patientLabel">Select City</label>{" "}
                    <select
                      className="patentInput"
                      name="city"
                      onChange={cityHandleSubmit}
                    >
                      {/* <option value="">Select City</option> */}
                      <option key={"Default_key_0"} value={""}>
                        Select City
                      </option>
                      {navCity && navCity.navCities && navCity.navCities.cities
                        ? navCities.cities.map((ele, index) => {
                            return (
                              <>
                                <option
                                  key={index}
                                  selected={ele == citySelected.citySelect}
                                  value={ele}
                                >
                                  {ele.replace("_", " ")}
                                </option>
                              </>
                            );
                          })
                        : "navCityLoading"}
                    </select>
                    <p className="error">{selectCityErr}</p>
                  </div>
                  <div
                    className="d_flex flex_column"
                    style={{ position: "relative" }}
                  >
                    <label className="patientLabel">PIN CODE</label>{" "}
                    <input
                      type="text"
                      placeholder="Enter PinCode"
                      value={areApin}
                      name="pincode"
                      className="patentInput"
                      onChange={handelPincode}
                      autoComplete="off"
                      required
                    ></input>
                    <p className="error pinCodeNotFound">{pincodeErr}</p>
                    {areApin && areApin !== "" && pinList && pincodeErr == "" && (
                      <div className="pincodeList patientPincode">
                        {pincodeLoading ? (
                          <Loader />
                        ) : (
                          <div>
                            {areaPincode===undefined?(
                               <p className="error pincodeError">
                               Not Serviceable Area
                             </p>
                            ):(
                              <p className="error pincodeError">
                              Please select pincode from list below
                            </p>
                            )}
                            {areaPincode &&
                              areaPincode.results &&
                              areaPincode.results.map((values, index) => {
                                if (index < 9) {
                                  return (
                                    <li
                                      key={values.id}
                                      onClick={() => handelPincodeList(values)}
                                    >
                                      {values.area} {values.pincode}
                                    </li>
                                  );
                                }
                              })}
                          </div>
                        )}
                      </div>
                    )}
                    {/**added pincode here end */}
                  </div>
                </div>
                <div className="bottom_form">
                  <div className="d_flex flex_column">
                    <label className="patientLabel  ">AGE</label>
                    <input
                      type="number"
                      placeholder="In Years"
                      min="1"
                      max="104"
                      name="year"
                      value={year}
                      className="miniInput patentInput"
                      onChange={patientHandleAge}
                      required
                    />
                    <p className="error">{yearErr}</p>
                  </div>

                  <div className="d_flex flex_column patientGenderBox">
                    <label className="patientLabel ">GENDER</label>
                    <div className="d_flex">
                      <label className="patientLabel">
                        <input
                          type="radio"
                          placeholder="Male"
                          value="male"
                          name="gender"
                          className="miniInput patentInput"
                          onChange={patientHandleGender}
                          style={{ marginRight: "1rem", height: "2rem" }}
                          required
                        />
                        <span className="male miniInput patentInput">Male</span>
                      </label>
                      <label className="patientLabel">
                        <input
                          type="radio"
                          placeholder="Female"
                          value="female"
                          name="gender"
                          className="miniInput"
                          onChange={patientHandleGender}
                          style={{ marginRight: "1rem", height: "2rem" }}
                          required
                        />
                        <span className="female miniInput patentInput">
                          Female
                        </span>
                      </label>
                    </div>
                    <p className="error">{genderErr}</p>
                  </div>
                </div>
                <div className="d_flex flex_column ">
                  <label className="patientLabel ">EMAIL ID</label>
                  <input
                    type="email"
                    className="patentInput"
                    placeholder="EMAIL ID"
                    name="email"
                    value={email}
                    onChange={patientHandleEmail}
                    required
                  />
                  <p className="error">{emailErr}</p>
                </div>
                <input type="submit" hidden />
              </form>
            </div>
          </div>
          <div className="cart_RightSide">
            <div className="mobilePatientForm">
              <div>
                <div className="booking_Razordiv">
                  <div className="topRazor">
                    <p>
                      <span className="textblueBold offerprice">
                        ₹{details !== "" ? offerSum : offerPrice && offerPrice}
                      </span>
                      &nbsp;{" "}
                      <span className="sellingPrice">
                        ₹{details !== "" ? sum : Mrp && Mrp}
                      </span>
                    </p>
                    {/* <span className="btn_neon">Get {discountPercentage}% OFF</span> */}
                    <span className="btn_neon">
                      Get{" "}
                      {details !== ""
                        ? discountPercent
                        : discountPercentage && discountPercentage}
                      % OFF
                    </span>
                  </div>
                  <div className="borderBook" />
                  <div className={showDetails ? "toogleBook" : "height0"}>
                    <div className="priceBreakParent">
                      <span>Home Collection Charges</span>
                      <div className="rightSidediv_booking">
                        {/* <span>₹250</span> */}
                        <span className="textSecondary">FREE</span>
                      </div>
                    </div>
                    <div className="borderBook" />

                    <div className="priceBreakParent">
                      <span>Offer Price</span>
                      <div>
                        {/* <span>₹{packageDetails?.package_price}</span> */}
                        {/* <span> ₹ {details !== "" && sum}</span> */}₹
                        {details !== "" ? offerSum : offerPrice && offerPrice}
                      </div>
                    </div>

                    <div className="priceBreakParent">
                      <span>Delivery Charges</span>
                      <div>
                        <span>₹{deliveryCharges}</span>
                      </div>
                    </div>

                    {/* <div className="priceBreakParent">
                      <span>Discount</span>
                      <div>
                        <span>₹ - {details !== "" && discountSum}</span>
                      </div>
                    </div> */}

                    {coupnDis > 0 ? (
                      <div className="priceBreakParent">
                        <span className="coupnSpan">
                          {localStorage?.getItem("is_redcash_applied") == "true"
                            ? "Redcash"
                            : localStorage?.getItem("giftcard") != null &&
                              localStorage?.getItem("giftcard") != ""
                            ? "Giftcard"
                            : "Coupon"}{" "}
                          Applied
                        </span>
                        <div>
                          <span>-₹ {coupnDis}</span>
                        </div>
                      </div>
                    ) : null}
                    <div className="borderBook" />

                    <div
                      className="priceBreakParent"
                      style={{
                        fontWeight: " 700",
                        fontSize: "1.8rem",
                        color: "#0a406b",
                      }}
                    >
                      <span>Total Amount</span>
                      <div>
                        <span>
                          ₹{" "}
                          {details !== ""
                            ? offerSum + deliveryCharges - coupnDis
                            : finalPrice && finalPrice}
                        </span>
                      </div>
                    </div>
                  </div>

                  <span className="guidelines">
                    *inclusive of all the taxes, fees and subject to
                    availability
                  </span>
                  <div className="borderBook" />
                </div>

                <div className="booking_RazordivM">
                  <p className="textSecondary note">
                    YOU SAVED Rs. {details !== "" && discountSum + coupnDis} ON
                    THIS BOOKING!
                  </p>
                  {/* <div className="coupnCODE">
          <input placeholder="Enter Coupon Code" />{" "}
          <span className="textpink"> Apply</span>
        </div> */}
                  <span className="add_tocart " onClick={handleSubmit}>
                    {details !== "" && discountSum ? "PROCEED" : "ADD TO CART"}{" "}
                  </span>
                </div>
              </div>
              {/* <BookForm empty={false} patientDetailF={patientFormn}/> */}
            </div>
          </div>
        </div>
      </div>
      <div className="mobileFooter">
        <p>
          Total Amount <br />
          <span style={{ fontWeight: "600" }}>
            Rs.{" "}
            {details !== "" && offerSum < 99
              ? offerSum + deliveryCharges - coupnDis
              : offerSum - coupnDis}
            /-
          </span>
        </p>
        <span
          className="add_tocart"
          style={{ borderRadius: "9px" }}
          onClick={handleSubmit}
        >
          PROCEED
        </span>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  userProfile: state?.Profile?.profileDate,
  PinCodeNotFound: state?.areaPincodeReducer?.error,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getProfileDetails: (token) => {
      dispatch(PatientActions.getProfileDetails(token));
    },
  };
};
export default {
  component: connect(
    mapStateToProps,
    mapDispatchToProps
  )(React.memo(PatientDetails)),
};
